/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JoinResponse
 */
export interface JoinResponse {
    /**
     * User Id
     * @type {string}
     * @memberof JoinResponse
     */
    userId?: string;
    /**
     * Name of an org
     * @type {string}
     * @memberof JoinResponse
     */
    orgName?: string;
    /**
     * Org emails domain
     * @type {string}
     * @memberof JoinResponse
     */
    domain?: string;
}

/**
 * Check if a given object implements the JoinResponse interface.
 */
export function instanceOfJoinResponse(value: object): boolean {
    return true;
}

export function JoinResponseFromJSON(json: any): JoinResponse {
    return JoinResponseFromJSONTyped(json, false);
}

export function JoinResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JoinResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'orgName': json['orgName'] == null ? undefined : json['orgName'],
        'domain': json['domain'] == null ? undefined : json['domain'],
    };
}

export function JoinResponseToJSON(value?: JoinResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userId': value['userId'],
        'orgName': value['orgName'],
        'domain': value['domain'],
    };
}

